import * as r from 'ramda';
import { call, put, takeLeading } from 'redux-saga/effects';

import * as actions from '../actions';
import { updateArtset } from '../helpers/updateArtset';
import { fetchSingleArtset } from '../helpers/fetchSingleArtset';

const deleteArtProduct = function* (artProductID) {
  const artsetToUpdate = yield call(fetchSingleArtset);
  const findProductByID = r.pathEq(['Configuration', 'Id'], artProductID);
  artsetToUpdate.Products = r.reject(findProductByID)(artsetToUpdate.Products);
  yield call(updateArtset, artsetToUpdate);
};

const submitArtProductDelete = function* ({ payload }) {
  const { artProductID } = payload;
  yield call(deleteArtProduct, artProductID);
  yield put(actions.fetchArtProducts());

  const { callbacks } = payload;
  callbacks.onSuccess();
};

export const deleteArtProductSaga = function* () {
  yield takeLeading(actions.submitArtProductDelete, submitArtProductDelete);
};
